import React from "react"
import toastMessages from "stores/toastMessages"
import { useList } from 'effector-react'
import ToastMessage from "components/ToastMessage/ToastMessage"
import "./ToastMessages.scss"
import Message from "models/Message"

const ToastMessages = () => {
    return (
        <div className="toast-messages">
            {
            useList(toastMessages.list, (message: Message, idx) => (
                    <ToastMessage key={idx} message={message} />
                ))
            }
        </div>
    )
}

export default ToastMessages
